import { CreateExcel } from "@jurinfor/js-excel";
import Sheet from "./Sheet";

export default class Spreadsheet {
  /**
   * @param {Sheet} sheets - массив страниц
   */
  constructor(sheets) {
    this.sheets = sheets;
  }

  /**
   * Порождает XLS-файл.
   */
  createExcel() {
    CreateExcel(
      this.sheets.map(({ title, frag: { data } }) => ({ title, data })),
      "",
      Object.fromEntries(this.sheets.map(({ title, frag }) => ([ title, frag.markdown ]))),
      Object.fromEntries(this.sheets.map(({ title, frag }) => ([ title, frag.columnWidth ]))),
      Object.fromEntries(this.sheets.map(({ title, frag }) => ([ title, frag.rowHeight ]))),
    );
  }
}
